// shop-the look

function waitForElem(
  waitFor,
  callback,
  minElements = 1,
  isVariable = false,
  timer = 10000,
  frequency = 25,
) {
  let elements = isVariable
    ? window[waitFor]
    : document.querySelectorAll(waitFor);
  if (timer <= 0) return;
  (!isVariable && elements.length >= minElements) ||
    (isVariable && typeof window[waitFor] !== "undefined")
    ? callback(elements)
    : setTimeout(
      () =>
        waitForElem(
          waitFor,
          callback,
          minElements,
          isVariable,
          timer - frequency,
        ),
      frequency,
    );
}

const OpenShopTheLookModal = () => {
  document
    .querySelector(".shop-the-look-modal-overlay")
    .classList.add("is-open");
  document.body.style.overflow = "hidden";
};
const CloseShopTheLookModal = () => {
  document
    .querySelector(".shop-the-look-modal-overlay")
    .classList.remove("is-open");
  document.body.style.overflow = "auto";
};
document.body?.addEventListener("click", (e) => {
  if (
    e.target == document.querySelector(".shop-the-look-modal-overlay") ||
    e.target.closest(".shop-the-look-modal-wrapper .close-icon")
  ) {
    CloseShopTheLookModal();
  }
});
waitForElem(
  ".shop-the-look-modal-content .product-details #product-variants .size ul li",
  () => {
    document
      .querySelectorAll(".shop-the-look-modal-wrapper button[type='submit']")
      .forEach((button) => {
        button?.addEventListener("click", () => {
          setTimeout(() => {
            juno.checkToggleBasketNavigation();
          }, 1200);
        });
      });
    document
      .querySelectorAll(
        ".shop-the-look-modal-content .product-details #product-variants .size ul li.active",
      )
      .forEach((item) => {
        item?.addEventListener("click", () => {
          const data_size = item.getAttribute("data-size") || "";
          item.closest(".size").querySelector("label").dataset.size = data_size;
          item.closest(".size").querySelector("label span").textContent =
            `Size: ${data_size}`;
          const itemId = item.getAttribute("data-id");
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form input[id='atc-product-id']").value =
            itemId;
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form button[type='submit']")
            .classList.remove("disable-atc");
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form button[type='submit']").textContent =
            "Add to Bag";
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(
              ".product-details #product-variants .size .product-option-size",
            )
            .classList.remove("active");
        });
      });
    document
      .querySelectorAll(
        ".shop-the-look-modal-content .product-details #product-variants .size label",
      )
      .forEach((item) => {
        item?.addEventListener("click", () => {
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(
              ".product-details #product-variants .size .product-option-size",
            )
            .classList.toggle("active");
        });
      });
  },
);
waitForElem(
  ".shop-the-look-modal-content #styledWith .blockHeader",
  ([heading]) => {
    heading.textContent = "SHOP THE LOOK";
  },
);

// shop-the look

// sticky-atc-bar
const stickyBar = document.getElementById("sticky-atc-bar");
if (stickyBar) {
  const mainForm = document.getElementById("ValidAddtoCart");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Check if the form is completely above the viewport (scrolled past)
        const isAboveViewport = entry.boundingClientRect.bottom < 0;
        stickyBar.classList.toggle("visible", isAboveViewport);
      });
    },
    { threshold: 0 }, // fire when any part enters or leaves the viewport
  );
  if (mainForm) observer.observe(mainForm);
}
// sticky-atc-bar

/* Back in Stock Modal Events */
var backInStockButton = document.querySelector("[data-modal-trigger]");
var backInStockModal = document.querySelector("[data-back-in-stock-modal]");
if (backInStockButton && backInStockModal) {
  backInStockButton?.addEventListener("click", function () {
    backInStockModal.classList.toggle("active");
  });
  backInStockModal
    .querySelectorAll("[data-close-modal-trigger]")
    .forEach(function (el) {
      el?.addEventListener("click", function () {
        backInStockModal.classList.remove("active");
      });
    });
}

/* Back in Stock Form */
if (backInStockButton && backInStockModal) {
  var selectors = {
    form: "[data-back-in-stock-form]",
    emailInput: "[data-back-in-stock-email]",
    errorMessage: "[data-back-in-stock-error]",
    productInput: "[data-back-in-stock-product]",
    submitButton: "[data-back-in-stock-submit]",
    successView: "[data-back-in-stock-success-view]",
    successMessage: "[data-back-in-stock-success]",
    variantInput: "[data-back-in-stock-variant]",
  };
  var form = document.querySelector(selectors.form);
  var emailInput = document.querySelector(selectors.emailInput);
  var errorMessageContainer = document.querySelector(selectors.errorMessage);
  var productInput = document.querySelector(selectors.productInput);
  var submitButton = document.querySelector(selectors.submitButton);
  var successMessageContainer = document.querySelector(
    selectors.successMessage,
  );
  var successView = document.querySelector(selectors.successView);
  var variantInput = document.querySelector(selectors.variantInput);

  function onSubmit(event) {
    event.preventDefault();
    if (!emailInput.value || emailInput.value.length === 0) {
      errorMessageContainer.textContent = "Please enter an email address";
      return;
    }
    if (variantInput.value && productInput.value) {
      submitButton.disabled = true;
      errorMessageContainer.textContent = "";
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: emailInput.value },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantInput.value}`,
              },
            },
          },
        },
      };
      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=W9kQzw",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(payload),
        },
      )
        .then((result) => {
          if (result.status == 202) {
            successMessageContainer.textContent = `Thank you, We'll notify you when it's back in stock.`;
            successView.classList.toggle("u-hide");
          } else {
            errorMessageContainer.textContent =
              "Something went wrong. Please try again in a moment.";
          }
        })
        .catch(() => {
          errorMessageContainer.textContent =
            "Something went wrong. Please try again in a moment.";
        });
    }
  }
  form?.addEventListener("submit", onSubmit);
}
/* Back in Stock Modal Events */

//   Personalization
const monogramErrorMessage = document.querySelector("#format-error");
const modal_wrapper = document.querySelector("#personalisation-modal-wrapper");
const personalisedButtonText = "Add your personalisation for £15";
const personalisedAtcButton = document.querySelector(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .personalised-atc-form button[type='submit']",
);
const regularAtcButton = document.querySelector(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .atc-form button[type='submit']",
);
const demoText = document.querySelector(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-image #customized-text-demo p",
);
const color_pickers = document.querySelectorAll(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .customization-content .color-picker ul li.color-item",
);
const allSelectFields = document.querySelectorAll(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization select",
);
const textField = document.querySelector(
  "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .customization-content .personalised-text input",
);
const timeOutFunction = (runFunction, timeOut) => {
  setTimeout(() => {
    runFunction();
  }, timeOut);
};
const resetModal = () => {
  allSelectFields.forEach((select) => {
    select.options[0].selected = true;
  });
  updateColorSwatchesActiveClass(color_pickers, color_pickers[0]);
  document
    .querySelectorAll(
      "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .personalised-atc-form input[data-default]",
    )
    .forEach((item) => {
      item.value = item.dataset["default"];
    });
  textField.value = "";
  demoText.textContent = "";
  demoText.setAttribute(
    "style",
    "color: #000; font-size: 14px; font-family: 'Ubuntu', sans-serif;",
  );
  checkValidation(textField.value);
  monogramErrorMessage.classList.remove("show");
  setTimeout(() => {
    personalisedAtcButton.textContent = personalisedButtonText;
    regularAtcButton.textContent = "continue without personalisation";
  }, 1500);
};
const openModal = () => {
  modal_wrapper.style.display = "flex";
  document.body.style.overflow = "hidden";
  document
    .querySelector(".product-details #AddToCartForm #variants-add-wrapper")
    .classList.add("hidden");
};
const closeModal = () => {
  modal_wrapper.style.display = "none";
  document.body.style.overflow = "auto";
  document
    .querySelector(".product-details #AddToCartForm #variants-add-wrapper")
    .classList.remove("hidden");
  resetModal();
};
const updateColorSwatchesActiveClass = (items, activeItem) => {
  items.forEach((item) => {
    item.classList.remove("active");
  });
  activeItem.classList.add("active");
};
const updateFormProperties = (select) => {
  const selectedItemDestination =
    select.options[select.options["selectedIndex"]].getAttribute("for");
  const selectedItemValue =
    select.options[select.options["selectedIndex"]].value;
  const targetElement = document.querySelector(
    `#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .personalised-atc-form input[data-value='${selectedItemDestination}']`,
  );
  targetElement.value = selectedItemValue;
  if (selectedItemDestination == "size") {
    demoText.style.fontSize = `${select.options[select.options["selectedIndex"]].getAttribute("demo-value")}`;
    demoText.className = `${selectedItemDestination}-${selectedItemValue}`;
  } else if (selectedItemDestination == "font") {
    demoText.style.fontFamily = `${select.options[select.options["selectedIndex"]].getAttribute("demo-value")}`;
  } else if (selectedItemDestination == "placement") {
    // {% comment %} demoText.closest("#customized-text-demo").setAttribute("style", `${select.options[select.options['selectedIndex']].getAttribute('demo-value')}`); {% endcomment %}
    demoText.closest("#customized-text-demo").className =
      `${selectedItemDestination}-${selectedItemValue}`;
  }
};
const addPersonalisationCharge = () => {
  document.querySelector("#personalisation-charge button").click();
};
const checkValidation = (value) => {
  // Define a regex pattern for 'v.v.v.', '.v.v', 'v.v' formats
  const isCuff =
    document.querySelector("[name='properties[_placement]']").value === "cuff";

  const pattern = isCuff
    ? /^(?:[a-zA-Z]{1,3}|([a-zA-Z]{2}\.[a-zA-Z])|([a-zA-Z]\.[a-zA-Z])|([a-zA-Z]{2}\.[a-zA-Z]\.)|([a-zA-Z]\.[a-zA-Z]{2}\.?)|([a-zA-Z]\.[a-zA-Z]\.[a-zA-Z]\.?)|([a-zA-Z]{1,3}\.?)|(\.[a-zA-Z]{1,2}\.[a-zA-Z]\.?)|(\.[a-zA-Z]\.[a-zA-Z]\.?)|([a-zA-Z]\.[a-zA-Z]{1,2}\.?)|(\.[a-zA-Z]{1,3}\.))$/
    : /^(?:[a-zA-Z]{1,2}|([a-zA-Z]{2}\.[a-zA-Z])|([a-zA-Z]\.[a-zA-Z])|([a-zA-Z]{2}\.[a-zA-Z]\.)|([a-zA-Z]\.[a-zA-Z]{2}\.?)|([a-zA-Z]\.[a-zA-Z]\.[a-zA-Z]\.?)|([a-zA-Z]{1,2}\.?)|(\.[a-zA-Z]{1,2}\.[a-zA-Z]\.?)|(\.[a-zA-Z]\.[a-zA-Z]\.?)|([a-zA-Z]\.[a-zA-Z]{1,2}\.?)|(\.[a-zA-Z]{1,2}\.))$/;

  if (pattern.test(value)) {
    // Hide error if format is valid
    monogramErrorMessage.classList.remove("show");
    personalisedAtcButton.classList.remove("disable-atc");
  } else {
    // Show error if format is invalid
    monogramErrorMessage.classList.add("show");
    personalisedAtcButton.classList.add("disable-atc");
  }
};
// {% comment %} personalise button click event {% endcomment %}
document
  .querySelector("#personalise-button .fake-atc-button")
  ?.addEventListener("click", () => {
    var variantSizes = document
      .querySelector(
        ".size label:not(.shop-the-look-modal-wrapper .size label)",
      )
      .getAttribute("data-size");
    if (variantSizes == "") {
      jQuery(".size-error").fadeIn();
    } else {
      jQuery(".size-error").fadeOut();
      openModal();
    }
  });
// {% comment %} personalise button click event {% endcomment %}
// {% comment %} event for size selectors {% endcomment %}
document
  .querySelectorAll(
    ".product-details #AddToCartForm #variants-add-wrapper #product-variants .selector.size-selector .size .product-option-size li.active",
  )
  .forEach((li) => {
    li?.addEventListener("click", () => {
      const selected_variant_id = li.getAttribute("data-id");
      document
        .querySelectorAll(
          "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section input#atc-product-id",
        )
        .forEach((input) => {
          input.value = selected_variant_id;
        });
      //   {% comment %} if (!document.querySelector('#AddToCartForm #product-add .fake-atc-button')) {
      //     document
      //       .querySelector('#AddToCartForm #product-add #AddToCartWrapper')
      //       .insertAdjacentHTML('afterend', `<div class="fake-atc-button button-custom">Personalise</div>`);
      //   } {% endcomment %}
    });
  });
//   {% comment %} event for modal close {% endcomment %}
document
  .querySelector(
    "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .close-modal .close-modal-button",
  )
  ?.addEventListener("click", () => {
    closeModal();
  });

//   {% comment %} event for all color swatches {% endcomment %}
color_pickers.forEach((li) => {
  li?.addEventListener("click", () => {
    updateColorSwatchesActiveClass(color_pickers, li);
    const color_name = li.children[0].getAttribute("data-color");
    const color_code = li.children[0].getAttribute("data-color-code");
    document.querySelector(
      "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .personalised-atc-form input[name='properties[_color]']",
    ).value = color_name;
    demoText.style.color = `${color_code}`;
  });
});

// {% comment %} event for text input {% endcomment %}
textField?.addEventListener("input", (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9.]/g, "");
  checkValidation(e.target.value);
  document.querySelector(
    "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section .personalised-atc-form input[name='properties[_monogram]']",
  ).value = e.target.value;
  demoText.textContent = e.target.value;
});
//   {% comment %} add event for all select items {% endcomment %}
allSelectFields.forEach((select) => {
  select?.addEventListener("change", () => {
    updateFormProperties(select);
  });
});
const extraChargeDiv = `  <div id="personalisation-charge" class="hidden">
        <form action="/cart/add" method="post" enctype="multipart/form-data">
          <input
            type="hidden"
            name="id"
            id="personalisation-charge"
            value="53479059259771"
          >
          <input type="hidden" name="quantity" value="1">
          <button type="submit" name="add" class=""></button>
        </form>
      </div>`;
document.body.insertAdjacentHTML("beforeend", extraChargeDiv);
// {% comment %} add 30 sec timer to the cart page and adding extra charge for personalization {% endcomment %}
let count = new Date(new Date().getTime() + 30 * 60 * 1000);
document
  .querySelectorAll(
    "#personalisation-modal-wrapper .personalisation-modal .content-wrapper .product-customization .ATC-section [type='submit']",
  )
  .forEach((button) => {
    button?.addEventListener("click", () => {
      localStorage.setItem("cartTimer", JSON.stringify(count));
      timeOutFunction(closeModal, 1200);
      timeOutFunction(juno.checkToggleBasketNavigation, 1300);
      // {% comment %} timeOutFunction(juno.checkToggleBasketNavigation, 4500); {% endcomment %}
      // {% comment %} if(button.closest(".personalised-atc-form")){
      //   timeOutFunction(addPersonalisationCharge, 1800);
      // } {% endcomment %}
    });
  });
//   Personalization
